import { compose, path } from "ramda"

export const setStateFromEvent = (setter, type) => event => {
  if (type === 'int') {
    setter(parseInt(event.target.value))
  } else {
    setter(event.target.value)
  }
}

export const setStateFromEventCheckbox = setter => compose(setter, path(['target', 'checked']))

export const ignoreBackdropClick = fn => (evt, reason) => reason !== 'backdropClick' && fn(evt)
